import { withAppContext } from '../components/AppContext';
import { Permissions } from 'utils/permissions';

const Access = can => ({ permission, app, children }) => {
    if (can(app, permission)) {
        return children;
    }
    return null;
};

const canView = (app, permission) => app.currentUser.canView(permission);

const canChange = (app, permission) => app.currentUser.canChange(permission);

export default {
    View: withAppContext(Access(canView)),
    Change: withAppContext(Access(canChange)),
    ...Permissions,
};
